import React from "react";
import PropTypes from "prop-types";
import SFAccordion, { SFAccordionDetails, SFAccordionSummary } from ".";
import SFTypography from "../typography";
import getStyled from "../../hooks/getStyled";
import SFDivider from "../divider";
import { SFArrowDownIcon } from "../icons";
const { styled } = getStyled();

const SFAccordionDetailsStyled = styled(SFAccordionDetails)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const SFAccordionStyled = styled(SFAccordion)(({ theme }) => ({
  borderRadius: "4px !important",
  border: `1px solid ${theme.palette.grey225.main}`,
}));

const SFDividerStyled = styled(SFDivider)(({ theme }) => ({
  borderColor: theme.palette.grey225.main,
}));

const SFAccordionCard = ({
  expanded,
  defaultExpanded,
  title,
  children,
  disabled,
  onChange,
  titleVariant = "h2",
  expandClickIconOnly = true,
  suppressDivider = false,
  className,
  reverse = false,
}) => {
  return (
    <SFAccordionStyled
      expanded={expanded}
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      {...(onChange && { onChange })}
      className={className}
    >
      <SFAccordionSummary
        expandIcon={<SFArrowDownIcon size="large" />}
        expandClickIconOnly={expandClickIconOnly}
        reverse={reverse}
      >
        {typeof title === "string" ? (
          <SFTypography variant={titleVariant}>{title}</SFTypography>
        ) : (
          title
        )}
      </SFAccordionSummary>
      {!suppressDivider && <SFDividerStyled />}
      <SFAccordionDetailsStyled>{children}</SFAccordionDetailsStyled>
    </SFAccordionStyled>
  );
};

export default SFAccordionCard;

SFAccordionCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  titleVariant: SFTypography.propTypes.variant,
  expandClickIconOnly: PropTypes.bool,
  suppressDivider: PropTypes.bool,
  className: PropTypes.string,
  reverse: PropTypes.bool,
};
